import { proxy } from 'valtio'
import { useQuery } from 'react-query'
import { CommonApi, SupplementalMaterialRequire } from '../../generated'
import { apiConfig } from '../apiConfig'
import { StudentType } from '../applications/StudenType'

export const supplementalMaterialRequireStore = proxy<{
  items: SupplementalMaterialRequire[]
}>({
  items: [],
})

const api = new CommonApi(apiConfig)

export async function loadSupplementalMaterialRequires() {
  const result = await api.getSupplementalMaterialRequires()
  supplementalMaterialRequireStore.items = result
  return result
}

export function useSupplementalMaterialRequire() {
  return useQuery(
    'supplemental-material-requires',
    loadSupplementalMaterialRequires
  )
}

export function useSupplementalMaterialRequires(studentType: StudentType, courseId: number | undefined): SupplementalMaterialRequire | undefined {
  if (courseId === undefined) return undefined
  const list = supplementalMaterialRequireStore.items
  const result = list.find((item) => {
    return item.courseId === courseId && item.studentType === studentType as string
  })
  return result
}
